export default "__VITE_ASSET__CGYRFCla__"